module.exports = __webpack_public_path__ + "static/img/fuhua.a79d832.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/fuhua.png
// module id = O3Is
// module chunks = 1